import * as React from "react";
import { ContentProps } from "components/flexComponents/Content/typings";
import { decorateEditorialHtml } from "components/flexComponents/Content/ContentUtilities";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkText } from "uitk-react-text";

export const CitiContent = (props: ContentProps) => {
  const flexComponent = props.flexComponent;
  const model = flexComponent && flexComponent.model;
  const items = (model && model.items && model.items.filter((item) => item)) || [];
  const maxItemsAllowed = 2;

  if (items.length !== maxItemsAllowed) {
    return null;
  }

  return (
    <UitkLayoutFlex space="two" wrap="wrap" justifyContent="center">
      <UitkLayoutFlexItem maxWidth="one_hundred_twenty">
        <UitkLayoutGrid rows={1}>
          <UitkLayoutGridItem>
            <div>
              <UitkText align="left" size={200}>
                <div className="all-t-padding-twelve" dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)} />
              </UitkText>
            </div>
          </UitkLayoutGridItem>

          <UitkLayoutGridItem>
            <div>
              <UitkText align="left" size={200}>
                <div className="all-b-padding-twelve" dangerouslySetInnerHTML={decorateEditorialHtml(items[1].text)} />
              </UitkText>
            </div>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  );
};

export default CitiContent;
